module.exports = __webpack_public_path__ + "static/media/image-5.ff77b18c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeDo/image-5.jpg
// module id = 348
// module chunks = 0